import * as React from 'react';
import queryString from 'query-string';
import { RouteComponentProps, withRouter } from 'react-router';
import { userManager } from 'servicesCommon/userManager';
import { Spin } from 'components/antd';
import { User } from 'oidc-client';

export interface PrivateRouteOwnProps extends RouteComponentProps<{}> {
	redirect: string;
}

export interface PrivateRouteState {
	user: User | null;
}

type ContextProps = {
	user: User | null;
};

// define context
const AuthContext = React.createContext<Partial<ContextProps>>({
	user: null,
});

//define provider
class PrivateRoute extends React.Component<PrivateRouteOwnProps, PrivateRouteState> {
	state = {
		user: null,
	};
	componentDidMount() {
		userManager.getUser().then(user => {
			if (!user || user.expired) {
				this.setState({ user: null });
				this.props.history.replace({
					pathname: this.props.redirect,
					search: queryString.stringify({
						returnUrl: [
							this.props.location ? this.props.location.pathname : null,
							this.props.location ? this.props.location.search : null,
						]
							.filter(_ => _)
							.join(''),
					}),
				});
			} else {
				this.setState({ user });
			}
		});
	}

	render() {
		return (
			<AuthContext.Provider value={{ user: this.state.user }}>
				{this.state.user ? this.props.children : <Spin spinning={true} isLoginSpin />}
			</AuthContext.Provider>
		);
	}
}

export default withRouter(PrivateRoute);

//define consumer
export function withAuthComponent(Component: any) {
	return function AuthenticatedComponent(props: any) {
		return (
			<AuthContext.Consumer>
				{({ user }) => <Component {...props} user={user} />}
			</AuthContext.Consumer>
		);
	};
}
